<template>
  <header class="gridx">
    <vs-navbar
      v-if="this.username == 'betagrodemo' || this.admin == 'betagrodemo'"
      v-model="indexActive"
      color="#121212"
      class="topnavbar"
      back
      text-color="red"
      active-text-color="red"
    >
      <!---
      Template logo
      -->
      <div slot="title" class="themelogo">
        <img :src="logo" v-if="logo" alt="Dashboard" :width="widthLogo" />
        <span class="logo-text" v-if="title">{{ title }}</span>
      </div>
      <!---
      Mobile toggle
      -->
      <div slot="title">
        <div class="cursor-pointer" @click.stop="activeSidebar">
          <vs-icon color="primary" icon="menu"></vs-icon>
        </div>
      </div>

      <vs-spacer></vs-spacer>

      <!---
      Craete new dd
      -->
      <!-- <vs-row vs-w="2">
        <input class="search__input" type="text" placeholder="Search">
       
        </vs-row>&nbsp;&nbsp; -->

      <!---
      Craete new dd
      -->

      <a class="mr-2" style="color: #ffffff"
        > {{ this.$session.get("username") }}</a
      >
      <!-- <vs-icon icon="notifications_active" size="27px" color="success"></vs-icon> -->
      <vs-dropdown vs-trigger-click>
        <span v-if="this.username != 'poonsak.ngk'">
          <vs-icon
            icon="notifications"
            size="27px"
            color="#32c040"
            v-if="alertlist.length == 0"
          ></vs-icon>

          <span
            v-else
            class="fa-stack has-badge"
            :data-count="lastAlert.length"
          >
            <vs-icon
              icon="notifications_active"
              size="27px"
              color="#32c040"
            ></vs-icon>
          </span>
        </span>
        <vs-dropdown-menu class="loginx">
          <div class="p-3 mb-2 text-dark">Notifications</div>
          <vs-list
            style="
              border-radius: 20px;
              height: auto;
              max-height: 400px;
              overflow-x: hidden;
            "
          >
            <span
              @click="viewAlert(item, aid[i])"
              v-for="(item, i) in lastAlert"
              :key="i"
            >
              <vs-list-item
                v-if="item.alertstatus"
                class="bgHoverDis"
                :title="item.alertname"
                :subtitle="$moment(item.timestamp).fromNow()"
              >
                <template slot="avatar">
                  <vs-icon
                    class="iconAvatarDis"
                    icon="signal_cellular_alt"
                  ></vs-icon>
                </template>
                <!-- <a class="fontTime"> {{$moment(item.timestamp).fromNow()}}</a> -->
              </vs-list-item>
              <vs-list-item
                v-else
                class="bgHover"
                :title="item.alertname"
                :subtitle="$moment(item.timestamp).fromNow()"
              >
                <template slot="avatar">
                  <vs-icon
                    class="iconAvatar"
                    icon="signal_cellular_alt"
                  ></vs-icon>
                </template>
              </vs-list-item>
            </span>
          </vs-list>
        </vs-dropdown-menu>
      </vs-dropdown>
      <!---
      Craete new dd
      -->
      <vs-dropdown vs-trigger-click left class="cursor-pointer pr-2 pl-2 mr-1">
        <!-- <a class="text-dark" href="#">
         
          <vs-button radius color="#5b5777" type="gradient" icon="person"></vs-button>
        </a> -->
        <span>
          <vs-icon icon="person" size="27px" color="#32c040"></vs-icon>
        </span>
        <vs-dropdown-menu class="topbar-dd">
          <vs-dropdown-item @click="logout">Log Out</vs-dropdown-item>
        </vs-dropdown-menu>
      </vs-dropdown>
    </vs-navbar>
    <!-- ////////////////////////////////////////////////////////// -->
    <vs-navbar
      v-else-if="this.username == 'pttdemo'"
      v-model="indexActive"
      :color="topbarColor"
      class="topnavbar"
      back
      text-color="red"
      active-text-color="red"
    >
      <!---
      Template logo
      -->

      <div slot="title" class="themelogo">
        <img
          src="../../../assets/images/logo/sentenance_logo.png"
          v-if="logo"
          alt="Dashboard"
          width="200px"
        />
        <span class="logo-text" v-if="title">{{ title }}</span>
      </div>
      <!---
      Mobile toggle
      -->
      <div slot="title">
        <div class="cursor-pointer" @click.stop="activeSidebar">
          <vs-icon color="primary" icon="menu"></vs-icon>
        </div>
      </div>

      <vs-spacer></vs-spacer>

      <!---
      Craete new dd
      -->
      <!-- <vs-row vs-w="2">
        <input class="search__input" type="text" placeholder="Search">
       
        </vs-row>&nbsp;&nbsp; -->

      <!---
      Craete new dd
      -->

      <a class="mr-2" style="color: #5b5777"
        >Hi, {{ this.$session.get("username") }}</a
      >
      <!-- <vs-icon icon="notifications_active" size="27px" color="success"></vs-icon> -->
      <vs-dropdown vs-trigger-click>
        <span v-if="this.username != 'poonsak.ngk'">
          <vs-icon
            icon="notifications"
            size="27px"
            color="grey"
            v-if="alertlist.length == 0"
          ></vs-icon>

          <span
            v-else
            class="fa-stack has-badge"
            :data-count="lastAlert.length"
          >
            <vs-icon
              icon="notifications_active"
              size="27px"
              color="grey"
            ></vs-icon>
          </span>
        </span>
        <vs-dropdown-menu class="loginx">
          <div class="p-3 mb-2 text-dark">Notifications</div>
          <vs-list
            style="
              border-radius: 20px;
              height: auto;
              max-height: 400px;
              overflow-x: hidden;
            "
          >
            <span
              @click="viewAlert(item, aid[i])"
              v-for="(item, i) in lastAlert"
              :key="i"
            >
              <vs-list-item
                v-if="item.alertstatus"
                class="bgHoverDis"
                :title="item.alertname"
                :subtitle="$moment(item.timestamp).fromNow()"
              >
                <template slot="avatar">
                  <vs-icon
                    class="iconAvatarDis"
                    icon="signal_cellular_alt"
                  ></vs-icon>
                </template>
                <!-- <a class="fontTime"> {{$moment(item.timestamp).fromNow()}}</a> -->
              </vs-list-item>
              <vs-list-item
                v-else
                class="bgHover"
                :title="item.alertname"
                :subtitle="$moment(item.timestamp).fromNow()"
              >
                <template slot="avatar">
                  <vs-icon
                    class="iconAvatar"
                    icon="signal_cellular_alt"
                  ></vs-icon>
                </template>
              </vs-list-item>
            </span>
          </vs-list>
        </vs-dropdown-menu>
      </vs-dropdown>
      <!---
      Craete new dd
      -->
      <vs-dropdown vs-trigger-click left class="cursor-pointer pr-2 pl-2 mr-1">
        <!-- <a class="text-dark" href="#">
         
          <vs-button radius color="#5b5777" type="gradient" icon="person"></vs-button>
        </a> -->
        <span>
          <vs-icon icon="person" size="27px" color="grey"></vs-icon>
        </span>
        <vs-dropdown-menu class="topbar-dd">
          <vs-dropdown-item @click="logout">Log Out</vs-dropdown-item>
        </vs-dropdown-menu>
      </vs-dropdown>
    </vs-navbar>

    <vs-navbar
      v-else-if="this.guestKubota == 'guest_kubota'"
      v-model="indexActive"
      class="topnavbar"
      back
      text-color="red"
      color="#FFFFFF"
      active-text-color="red"
    >
      <!---
      Template logo
      -->

      <div slot="title" class="themelogo">
        <img
          src="../../../assets/images/kubota/LOGO KUBOTA 2018 (2).png"
          v-if="logo"
          alt="Dashboard"
          width="200px"
        />
      </div>
      <!---
      Mobile toggle
      -->
    </vs-navbar>

    <!-- <vs-navbar
      v-else-if="this.username == 'yamahademo'"
      v-model="indexActive"
      :color="topbarColor"
      class="topnavbar"
      back
      text-color="red"
      active-text-color="red"
    >
   
      <div slot="title" class="themelogo">
        <img
          src="../../../assets/images/logo/sentenance_logo.png"
          v-if="logo"
          alt="Dashboard"
          width="200px"
        />
        <span class="logo-text" v-if="title">{{ title }}</span>
      </div>
    
      <div slot="title">
        <div class="cursor-pointer" @click.stop="activeSidebar">
          <vs-icon color="primary" icon="menu"></vs-icon>
        </div>
      </div>

      <vs-spacer></vs-spacer>

   
      <a class="mr-2" style="color: #5b5777"
        >Hi, {{ this.$session.get("username") }}</a
      >
      <vs-dropdown vs-trigger-click>
        <span v-if="this.username != 'poonsak.ngk'">
          <vs-icon
            icon="notifications"
            size="27px"
            color="grey"
            v-if="alertlist.length == 0"
          ></vs-icon>

          <span
            v-else
            class="fa-stack has-badge"
            :data-count="lastAlert.length"
          >
            <vs-icon
              icon="notifications_active"
              size="27px"
              color="grey"
            ></vs-icon>
          </span>
        </span>
        <vs-dropdown-menu class="loginx">
          <div class="p-3 mb-2 text-dark">Notifications</div>
          <vs-list
            style="
              border-radius: 20px;
              height: auto;
              max-height: 400px;
              overflow-x: hidden;
            "
          >
            <span
              @click="viewAlert(item, aid[i])"
              v-for="(item, i) in lastAlert"
              :key="i"
            >
              <vs-list-item
                v-if="item.alertstatus"
                class="bgHoverDis"
                :title="item.alertname"
                :subtitle="$moment(item.timestamp).fromNow()"
              >
                <template slot="avatar">
                  <vs-icon
                    class="iconAvatarDis"
                    icon="signal_cellular_alt"
                  ></vs-icon>
                </template>
              </vs-list-item>
              <vs-list-item
                v-else
                class="bgHover"
                :title="item.alertname"
                :subtitle="$moment(item.timestamp).fromNow()"
              >
                <template slot="avatar">
                  <vs-icon
                    class="iconAvatar"
                    icon="signal_cellular_alt"
                  ></vs-icon>
                </template>
              </vs-list-item>
            </span>
          </vs-list>
        </vs-dropdown-menu>
      </vs-dropdown>
      <vs-dropdown vs-trigger-click left class="cursor-pointer pr-2 pl-2 mr-1">
        <span>
          <vs-icon icon="person" size="27px" color="grey"></vs-icon>
        </span>
        <vs-dropdown-menu class="topbar-dd">
          <vs-dropdown-item @click="logout">Log Out</vs-dropdown-item>
        </vs-dropdown-menu>
      </vs-dropdown>
    </vs-navbar>-->

    <vs-navbar
      v-else-if="this.username == 'i-APCdemo'"
      v-model="indexActive"
      class="topnavbar"
      back
      text-color="red"
      active-text-color="red"
    >
      <!---
      :color="topbarColor"
      Template logo
      -->
      <div slot="title" class="themelogo">
        <img
          src="../../../assets/images/logo/sentenance_logo.png"
          v-if="logo"
          alt="Dashboard"
          width="200px"
        />
        <span class="logo-text" v-if="title">{{ title }}</span>
      </div>
      <!---
      Mobile toggle
      -->
      <div slot="title">
        <div class="cursor-pointer" @click.stop="activeSidebar">
          <vs-icon color="primary" icon="menu"></vs-icon>
        </div>
      </div>

      <vs-spacer></vs-spacer>

      <!---
      Craete new dd
      -->
      <!-- <vs-row vs-w="2">
        <input class="search__input" type="text" placeholder="Search">
       
        </vs-row>&nbsp;&nbsp; -->

      <!---
      Craete new dd
      -->

      <span class="user-name mr-2" style="color: #5b5777"
        >Hi, {{ this.$session.get("username") }}</span
      >

      <!-- <vs-icon icon="notifications_active" size="27px" color="success"></vs-icon> -->
      <vs-dropdown vs-trigger-click>
        <span v-if="this.username != 'poonsak.ngk'">
          <vs-icon
            icon="notifications"
            size="27px"
            class="mode"
            v-if="alertlist.length == 0"
          ></vs-icon>

          <span
            v-else
            class="fa-stack has-badge"
            :data-count="lastAlert.length"
          >
            <vs-icon
              icon="notifications_active"
              size="27px"
              class="mode"
            ></vs-icon>
          </span>
        </span>
        <vs-dropdown-menu class="loginx">
          <div class="p-3 mb-2">Notifications</div>
          <vs-list
            style="
              border-radius: 20px;
              height: auto;
              max-height: 400px;
              overflow-x: hidden;
            "
          >
            <span
              @click="viewAlert(item, aid[i])"
              v-for="(item, i) in lastAlert"
              :key="i"
            >
              <vs-list-item
                v-if="item.alertstatus"
                class="bgHoverDis"
                :title="item.alertname"
                :subtitle="$moment(item.timestamp).fromNow()"
              >
                <template slot="avatar">
                  <vs-icon
                    class="iconAvatarDis"
                    icon="signal_cellular_alt"
                  ></vs-icon>
                </template>
                <!-- <a class="fontTime"> {{$moment(item.timestamp).fromNow()}}</a> -->
              </vs-list-item>
              <vs-list-item
                v-else
                class="bgHover"
                :title="item.alertname"
                :subtitle="$moment(item.timestamp).fromNow()"
              >
                <template slot="avatar">
                  <vs-icon
                    class="iconAvatar"
                    icon="signal_cellular_alt"
                  ></vs-icon>
                </template>
              </vs-list-item>
            </span>
          </vs-list>
        </vs-dropdown-menu>
      </vs-dropdown>
      <!---
      Craete new dd
      -->
      <vs-dropdown vs-trigger-click left class="cursor-pointer pr-2 pl-2 mr-1">
        <!-- <a class="text-dark" href="#">
         
          <vs-button radius color="#5b5777" type="gradient" icon="person"></vs-button>
        </a> -->
        <span>
          <vs-icon icon="person" size="27px" class="mode"></vs-icon>
        </span>
        <vs-dropdown-menu class="topbar-dd">
          <vs-dropdown-item @click="logout">Log Out</vs-dropdown-item>
        </vs-dropdown-menu>
      </vs-dropdown>
    </vs-navbar>

    <vs-navbar
      v-else
      v-model="indexActive"
      class="topnavbar"
      back
      color
      text-color="red"
      active-text-color="red"
    >
      <!---
      Template logo
      -->
      <!-- Enco -->
      <!-- <div v-if="username === 'encodemo'" slot="title" class="themelogo">
        <img
          src="../../../assets/images/logo/Untitled design (1).png"
          style="width: 9.375rem; height: 4.063rem"
          v-if="logo"
          alt="Dashboard"
        />
        <span class="logo-text" v-if="title">{{ title }}</span>
      </div> -->
      <!-- Enco -->
      <!-- <div v-else-if="username === 'Rivacold01'" slot="title" class="themelogo">
        <img
          src="../../../assets/images/rivacold/logo_rivacold_png.png"
          style="width: 13.375rem; height: 3rem; "
          class="ml-3"
          v-if="logo"
          alt="Dashboard"
        />
        <span class="logo-text" v-if="title">{{ title }}</span>
      </div> -->
      <!-- <div v-else-if="username === 'kubotademo'" slot="title" class="themelogo">
        <img
          src="../../../assets/images/kubota/LOGO KUBOTA 2018 (2).png"
          style="width: 60%; height: 60%; "
          class="ml-3"
          v-if="logo"
          alt="Dashboard"
        />
        <span class="logo-text" v-if="title">{{ title }}</span>
      </div> -->
      <div slot="title" class="themelogo">
        <img :src="logo" v-if="logo" alt="Dashboard" :width="widthLogo" />
        <span class="logo-text" v-if="title">{{ title }}</span>
      </div>
      <!---
      Mobile toggle
      -->

      <div v-if="this.username == 'yamahademo'" slot="title">
        <div class="cursor-pointer" @click.stop="activeSidebar">
          <vs-icon color="primary" icon="menu"></vs-icon>
        </div>
      </div>
      <div v-else slot="title">
        <div class="cursor-pointer" @click.stop="activeSidebar">
          <vs-icon color="primary" icon="menu"></vs-icon>
        </div>
      </div>
      <vs-spacer></vs-spacer>
      <a class="mr-2">Hi, {{ this.$session.get("username") }}</a>
      <button class="btn-mode">
        <vs-icon :icon="icon_mode" class="mode" @click="onMode"></vs-icon>
      </button>
      <!-- <vs-icon icon="notifications_active" size="27px" color="success"></vs-icon> -->
      <vs-dropdown vs-trigger-click>
        <span v-if="this.username != 'poonsak.ngk'">
          <vs-icon
            icon="notifications"
            size="27px"
            class="mode"
            v-if="alertlist.length == 0"
          ></vs-icon>

          <span
            v-else
            class="fa-stack has-badge"
            :data-count="lastAlert.length"
          >
            <vs-icon
              icon="notifications_active"
              size="27px"
              class="mode"
            ></vs-icon>
          </span>
        </span>
        <vs-dropdown-menu class="loginx">
          <div class="p-3 mb-2">Notifications</div>
          <vs-list
            style="
              border-radius: 20px;
              height: auto;
              max-height: 400px;
              overflow-x: hidden;
            "
          >
            <span
              @click="viewAlert(item, aid[i])"
              v-for="(item, i) in lastAlert"
              :key="i"
            >
              <vs-list-item
                v-if="item.alertstatus"
                class="bgHoverDis"
                :title="item.alertname"
                :subtitle="$moment(item.timestamp).fromNow()"
              >
                <template slot="avatar">
                  <vs-icon
                    class="iconAvatarDis"
                    icon="signal_cellular_alt"
                  ></vs-icon>
                </template>
                <!-- <a class="fontTime"> {{$moment(item.timestamp).fromNow()}}</a> -->
              </vs-list-item>
              <vs-list-item
                v-else
                class="bgHover"
                :title="item.alertname"
                :subtitle="$moment(item.timestamp).fromNow()"
              >
                <template slot="avatar">
                  <vs-icon
                    class="iconAvatar"
                    icon="signal_cellular_alt"
                  ></vs-icon>
                </template>
              </vs-list-item>
            </span>
          </vs-list>
        </vs-dropdown-menu>
      </vs-dropdown>
      <!---
      Craete new dd
      -->
      <vs-dropdown vs-trigger-click class="cursor-pointer">
        <!-- <a class="text-dark" href="#">
         
          <vs-button radius color="#5b5777" type="gradient" icon="person"></vs-button>
        </a> -->
        <span>
          <vs-icon icon="person" size="27px" class="mode"></vs-icon>
        </span>
        <vs-dropdown-menu class="topbar-dd">
          <vs-dropdown-item @click="logout">Log Out</vs-dropdown-item>
        </vs-dropdown-menu>
      </vs-dropdown>
      <v-google-translate :languages="lg" />
      <vs-dropdown vs-trigger-click left class="cursor-pointer pr-2 pl-2 mr-1">
        <span>
          <icon-base
            viewBox="0 0 34 30"
            icon-name="Air-Condition"
            width="26"
            height="26"
            class="mode"
            ><icon-nine-dot
          /></icon-base>
          <!-- :iconColor="icon_nav_color" -->
        </span>
        <vs-dropdown-menu class="topbar-dd-gosite">
          <vs-dropdown-item href="https://demo.sitearound.com/" target="_blank">
            <div class="img-item">
              <img src="@/assets/images/sentenance/sar_logo_1.png" alt="" />
            </div>
          </vs-dropdown-item>
        </vs-dropdown-menu>
      </vs-dropdown>
    </vs-navbar>
  </header>
</template>

<script>
import useSound from "vue-use-sound";
import buttonSfx from "../../../assets/sound/YRL6BSM-siren.mp3";
import IconNineDot from "@/assets/icon/Icons/IconNineDot.vue";

export default {
  setup() {
    const [play] = useSound(buttonSfx);

    return {
      play,
    };
  },
  components: {
    IconNineDot,
  },
  name: "Navbar",
  props: {
    topbarColor: {
      type: String,
      default: "#4F5467",
    },
    title: {
      type: String,
    },
    logo: {
      type: String,
    },
    widthLogo: String,
  },
  data: () => ({
    indexActive: 0,
    lg: [
      {
        code: "en",
        name: "English",
        cname: "英语",
        ename: "English",
      },
      {
        code: "th",
        name: "ไทย",
        cname: "泰语",
        ename: "Thai",
      },
    ],
    showToggle: false,
    search: "",
    guestKubota: "",
    network: "",
    alertlist: [],
    aid: [],
    username: "",
    admin: "",
    lastAlert: [],
    sensorId: [],
    oldLength: 0,
    firstLogin: true,
    icon_mode: "light_mode",
  }),
  async mounted() {
    let mode = await this.$store.dispatch("getCookie", "theme_mode");
    console.log("mode", mode);
    if (mode != null) {
      this.$store.commit("mode", mode);
      var r = document.querySelector(":root");

      if (this.$store.getters["mode"] == "dark_mode") {
        this.$store.dispatch("setCookie", {
          name: "theme_mode",
          value: "dark_mode",
          days: 7,
        });
        this.$store.commit("mode", "dark_mode");
        this.icon_mode = "dark_mode";
        r.style.setProperty("--background-color", "#000");
        r.style.setProperty("--background-color-sidebar", "#121212");
        r.style.setProperty("--background-color-navbar", "#121212");
        r.style.setProperty("--text-color", "#fff");
        r.style.setProperty("--text-color-2", "#fff");
        r.style.setProperty("--icon-navbar", "#32C040");
        r.style.setProperty("--background-login", "#000");
        // r.style.setProperty("--background-color", "#1E272E");
        // r.style.setProperty("--background-color-sidebar", "#2B343B");
        // r.style.setProperty("--background-color-navbar", "#2B343B");
        // r.style.setProperty("--text-color", "#fff");
        // r.style.setProperty("--icon-navbar", "#32C040");
        // r.style.setProperty("--background-login", "#1E272E");
      } else {
        this.$store.dispatch("setCookie", {
          name: "theme_mode",
          value: "light_mode",
          days: 7,
        });
        this.$store.commit("mode", "light_mode");
        this.icon_mode = "light_mode";
        r.style.setProperty("--background-color", "#fff");
        r.style.setProperty("--background-color-sidebar", "#fff");
        r.style.setProperty("--background-color-navbar", "#fff");
        r.style.setProperty("--text-color", "#000");
        r.style.setProperty("--text-color-2", "#808080");
        r.style.setProperty("--icon-navbar", "#808080");
        r.style.setProperty("--background-login", "#f6f6f6");
      }
    }
  },
  methods: {
    onMode() {
      console.log(this.$store.getters["mode"]);
      var r = document.querySelector(":root");
      if (this.$store.getters["mode"] == "dark_mode") {
        this.$store.dispatch("setCookie", {
          name: "theme_mode",
          value: "light_mode",
          days: 7,
        });
        this.$store.commit("mode", "light_mode");
        this.icon_mode = "light_mode";
        r.style.setProperty("--background-color", "#fff");
        r.style.setProperty("--background-color-sidebar", "#fff");
        r.style.setProperty("--background-color-navbar", "#fff");
        r.style.setProperty("--text-color", "#000");
        r.style.setProperty("--text-color-2", "#808080");
        r.style.setProperty("--icon-navbar", "#808080");
      } else {
        this.$store.dispatch("setCookie", {
          name: "theme_mode",
          value: "dark_mode",
          days: 7,
        });
        this.$store.commit("mode", "dark_mode");
        this.icon_mode = "dark_mode";
        r.style.setProperty("--background-color", "#1E272E");
        r.style.setProperty("--background-color-sidebar", "#2B343B");
        r.style.setProperty("--background-color-navbar", "#2B343B");
        r.style.setProperty("--text-color", "#fff");
        r.style.setProperty("--text-color-2", "#fff");
        r.style.setProperty("--icon-navbar", "#32C040");
      }
    },
    viewAlert(item, id) {
      // console.log(item);
      this.dataIdSensor = id;
      this.dataAlert = item;
      // console.log(this.dataAlert);
      // console.log(this.dataIdSensor);
      this.$session.set("dataAlert", this.dataAlert);
      this.$session.set("dataIdSensor", this.dataIdSensor);
      // this.$router.push({
      //   name: "ViewAlert",
      //   params: { dataAlert: this.dataAlert, dataIdSensor: this.dataIdSensor }
      // });
      if (this.$route.name == "ViewAlert") {
        location.reload();
      } else {
        this.$router.push({
          name: "ViewAlert",
          params: {
            dataAlert: this.dataAlert,
            dataIdSensor: this.dataIdSensor,
          },
        });
      }
      // console.log(this.$route.name);
      // location.reload();
    },
    logout() {
      this.$session.clear();
      this.$router.push({ path: "/login" });
    },
    //This is for sidebar trigger in mobile
    activeSidebar() {
      if (this.$store.state.isSidebarActive) {
        this.$store.commit("IS_SIDEBAR_ACTIVE", false);
      } else {
        this.$store.commit("IS_SIDEBAR_ACTIVE", true);
      }
    },
    async getAlertData() {
      var tempAlert = [];
      var tempLast = [];
      this.role = this.$session.get("role");
      var tempel = {};
      var JSONcon = {};

      await this.$API.get("sensors/indoor/user").then((result) => {
        // console.log(this.sensorlist)
        this.sensorlist = result.data;
      });

      this.lastAlert = [];
      this.alertlist = [];
      
      await this.$API.get("sensors/user").then((result) => {
        this.sensorlist = result.data;
      });
      await this.$API.get("alertlog/user").then((result) => {
        console.log(result.data);
        result.data.forEach((element) => {
          JSONcon = JSON.parse(element.con);
          let sensor = this.sensorlist;
          // console.log(sensor);
          // let sensor = this.sensorlist.filter(
          //   (sensor) => sensor.name == element.sensorname
          // );
          if (sensor.length == 0) console.log("no sensor found");
          let count = 0;
          if (Array.isArray(element.alerthistory)) {
            element.alerthistory.forEach((el) => {
              count += 1;
              this.aid.push(element.id);
              this.sensorId.push(sensor[0].id);
              el.alertid = count;
              tempel = el;
              tempel.alertname = element.alertname;
              tempel.alertstatus = element.alertstatus;
              tempel.sensorname = JSONcon.loracon;
              // tempel.sensorname = "test"
              tempel.sensorid = sensor[0].id;
              this.alertlist.push(el);
              tempel = {};
            });
            let lastAlert =
              element.alerthistory[element.alerthistory.length - 1];
              console.log(lastAlert)
            if (lastAlert.alertstatus == true) temp.push(lastAlert);
          } else {
            count += 1;
            this.aid.push(element.id);
            this.sensorId.push(sensor[0].id);
            element.alerthistory.alertid = count;
            tempel = element.alerthistory;
            tempel.alertname = element.alertname;
            tempel.alertstatus = element.alerthistory.alertstatus;
            tempel.sensorname = JSONcon.senname.name;
            tempel.sensorid = sensor[0].id;
            this.alertlist.push(element.alerthistory);
            tempel = {};
            let lastAlert =
              element.alerthistory[element.alerthistory.length - 1];
            // console.log(this.alertlist);
            temp.push(lastAlert);
          }
        })
      })
      this.interval = setTimeout(() => {
      this.getAlertData();
    }, 30000);
    },
  },

  async created() {
    this.username = this.$session.get("username");
    this.admin = this.$session.get("admin");
    this.guestKubota = this.$session.get("guestKubotauser");
    this.getAlertData();
    
  },
  beforeDestroy() {
    clearTimeout(this.interval);
  },
};
</script>
<style lang="stylus">
.vs-con-input {
  border: 1px solid rgba(0, 0, 0, 0);
  border-radius: 25px;
}

.search {
  &__container {
    padding-top: 64px;
  }

  &__title {
    font-size: 22px;
    font-weight: 900;
    text-align: center;
    color: #ff8b88;
  }

  &__input {
    width: 100%;
    padding: 12px 24px;
    background-color: transparent;
    transition: transform 250ms ease-in-out;
    font-size: 14px;
    line-height: 18px;
    color: #575756;
    background-color: transparent;
    /* background-image: url(http://mihaeltomic.com/codepen/input-search/ic_search_black_24px.svg); */
    background-image: url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24'%3E%3Cpath d='M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z'/%3E%3Cpath d='M0 0h24v24H0z' fill='none'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-size: 18px 18px;
    background-position: 95% center;
    border-radius: 50px;
    border: 1px solid #575756;
    transition: all 250ms ease-in-out;
    backface-visibility: hidden;
    transform-style: preserve-3d;

    &::placeholder {
      color: color(#575756 a(0.8));
      text-transform: uppercase;
      letter-spacing: 1.5px;
    }

    &:hover, &:focus {
      padding: 12px 0;
      outline: 0;
      border: 1px solid transparent;
      border-bottom: 1px solid #575756;
      border-radius: 0;
      background-position: 100% center;
    }
  }
}

.credits {
  &__container {
    margin-top: 24px;
  }

  &__text {
    text-align: center;
    font-size: 13px;
    line-height: 18px;
  }

  &__link {
    color: #ff8b88;
    text-decoration: none;
    transition: color 250ms ease-in;

    &:hover, &:focus {
      color: color(#ff8b88 blackness(+25%));
    }
  }
}
</style>
<style scoped>
.fa-stack[data-count]:after {
  position: absolute;
  right: -15%;
  top: -15%;
  content: attr(data-count);
  font-size: 60%;
  padding: 0.8em;
  border-radius: 999px;
  line-height: 0.9em;
  color: white;
  background: rgba(255, 0, 0, 0.85);
  text-align: center;
  min-width: 3em;
  font-weight: bold;
}
.vs-list--subtitle {
  font-size: 0.2rem;
}
.bgHover:hover {
  background: rgba(var(--vs-primary), 0.08);
  cursor: pointer;
}
.iconAvatar {
  padding: 8px;
  background: rgba(var(--vs-primary), 0.08);
  color: #32c040;
  font-size: 25px;
  border-radius: 50%;
  margin-right: 15px;
}
.bgHoverDis:hover {
  background: rgba(var(--vs-warning), 0.08);
  cursor: pointer;
}
.iconAvatarDis {
  padding: 8px;
  background: rgba(var(--vs-warning), 0.08);
  color: #ff911e;
  font-size: 25px;
  border-radius: 50%;
  margin-right: 15px;
}
.bg-success {
  background-color: #32c040 !important;
}
.con-vs-dropdown--menu {
  width: 350px;
}
</style>
<style lang="scss" scoped>
.btn-mode {
  background-color: transparent;
  border: none;
}
.mode {
  cursor: pointer;
  margin: 0 5px;
  color: var(--icon-navbar);
}
.topbar-dd-gosite {
  .img-item {
    display: flex;
    justify-content: center;
    img {
      // width: 70%;
      height: 30px;
      // margin-left: 50px;
    }
  }
}
</style>

